import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/base/ScrollToTop';
import ScrollToTopButton from '@/components/base/ScrollToTopButton';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/base/SchemaOrg';

export default function AboutPage() {
  return (
    <>
      <SchemaOrg
        data={{
          '@context': 'https://schema.org',
          '@graph': [
            {
              '@type': 'Organization',
              name: '韩漫网',
              url: 'https://www.manhwa-read.com/',
              description: '韩漫网是领先的中文韩国漫画在线阅读平台，提供海量免费韩国漫画资源，覆盖多种题材，高清画质流畅阅读。',
              foundingDate: '2020',
              contactPoint: [
                {
                  '@type': 'ContactPoint',
                  email: 'contact@manhwa-read.com',
                  contactType: 'customer service',
                },
                {
                  '@type': 'ContactPoint',
                  email: 'business@manhwa-read.com',
                  contactType: 'sales',
                },
              ],
            },
            {
              '@type': 'FAQPage',
              mainEntity: [
                {
                  '@type': 'Question',
                  name: '韩漫网上的漫画真的免费吗？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '是的，韩漫网上所有漫画资源均免费提供阅读。我们通过广告赞助和合作推广维持网站运营，不会向读者收取任何费用。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '是否需要注册账号才能阅读？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '不需要。韩漫网支持无需注册即可直接阅读所有漫画，打开网站就能立即开始。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '漫画更新频率是怎样的？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '热门漫画通常在韩国发布后24小时内同步更新中文翻译版本。一般漫画的更新周期为1-7天不等。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '支持哪些设备阅读？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '韩漫网全面适配PC电脑、平板电脑和手机等各类设备，无论使用什么设备都能获得最佳阅读体验。',
                  },
                },
                {
                  '@type': 'Question',
                  name: '如何找到我想看的漫画？',
                  acceptedAnswer: {
                    '@type': 'Answer',
                    text: '您可以通过首页的分类导航、搜索功能或热门推荐来找到感兴趣的漫画。分类系统涵盖所有主流漫画类型。',
                  },
                },
              ],
            },
            {
              '@type': 'WebPage',
              name: '关于我们 - 韩漫网',
              url: 'https://www.manhwa-read.com/about',
              description: '了解韩漫网品牌故事、读者口碑评价以及联系方式。韩漫网是领先的中文韩国漫画在线阅读平台。',
              inLanguage: 'zh-CN',
            },
            {
              '@type': 'BreadcrumbList',
              itemListElement: [
                {
                  '@type': 'ListItem',
                  position: 1,
                  name: '首页',
                  item: 'https://www.manhwa-read.com/',
                },
                {
                  '@type': 'ListItem',
                  position: 2,
                  name: '关于我们',
                },
              ],
            },
          ],
        }}
      />
      <ScrollToTop />
      <Navbar />

      <main className="pt-16">
        <Breadcrumb
          items={[
            { label: '首页', href: '/' },
            { label: '关于我们' },
          ]}
        />

        {/* Brand Introduction */}
        <section className="px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <h1 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 text-center mb-4">
              关于韩漫网
            </h1>
            <p className="text-sm text-foreground-600 text-center mb-10 max-w-2xl mx-auto">
              韩漫网是领先的中文韩国漫画在线阅读平台，致力于为广大漫画爱好者提供最优质的阅读体验
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
              <div className="relative h-64 md:h-80 rounded-lg overflow-hidden">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20cozy%20modern%20reading%20space%20with%20warm%20lighting%2C%20bookshelves%20filled%20with%20comics%2C%20comfortable%20seating%2C%20artistic%20atmosphere%2C%20Korean%20aesthetic%2C%20warm%20amber%20tones%2C%20editorial%20photography%20style%2C%20clean%20composition&width=800&height=600&seq=about-brand-01&orientation=landscape"
                  alt="韩漫网品牌形象"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="flex flex-col justify-center">
                <h2 className="text-lg md:text-xl font-bold font-heading text-foreground-950 mb-4">
                  我们的品牌故事
                </h2>
                <div className="text-sm text-foreground-600 leading-relaxed space-y-3">
                  <p>
                    韩漫网成立于2020年，是专注于韩国漫画中文翻译和在线阅读的先锋平台。我们的创始团队由一群热爱韩国漫画的资深读者组成，深知漫迷们对优质阅读体验的渴望。
                  </p>
                  <p>
                    经过多年发展，韩漫网已收录超过一万部精品韩国漫画，覆盖浪漫爱情、奇幻冒险、热血动作、都市剧情等各类题材。我们与多家韩国知名漫画平台建立合作关系，确保第一时间为读者带来最新、最精彩的漫画内容。
                  </p>
                  <p>
                    我们的使命是让每一位中文读者都能便捷、免费地享受韩国漫画的魅力。无论您是资深漫迷还是初次接触韩漫的新读者，韩漫网都将为您提供最好的阅读体验。
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Reputation / Testimonials */}
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 text-center mb-2">
              读者口碑
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-8">来自漫画爱好者的真实评价</p>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
              {[
                {
                  name: '小李',
                  role: '资深漫迷',
                  content: '韩漫网是我用过最好的韩国漫画阅读平台！更新速度超级快，画质也非常清晰。最让我感动的是完全免费，再也不用到处找资源了。',
                  rating: 5,
                },
                {
                  name: '王姐',
                  role: '大学生',
                  content: '分类导航特别方便，很容易就能找到自己喜欢的类型。手机上阅读体验也很好，每天睡前必刷几话。已经推荐给整个宿舍了！',
                  rating: 5,
                },
                {
                  name: '张先生',
                  role: '上班族',
                  content: '通勤时间全靠韩漫网消磨，资源真的超级丰富，各种类型的漫画都有。界面简洁干净，没有乱七八糟的广告，体验非常棒。',
                  rating: 5,
                },
              ].map((testimonial) => (
                <div key={testimonial.name} className="bg-background-50 rounded-lg p-5">
                  <div className="flex items-center gap-1 mb-3">
                    {Array.from({ length: testimonial.rating }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm text-[oklch(var(--accent-500))]" />
                    ))}
                  </div>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                    &ldquo;{testimonial.content}&rdquo;
                  </p>
                  <div className="flex items-center gap-3">
                    <div className="w-8 h-8 rounded-full bg-[oklch(var(--accent-100))] flex items-center justify-center">
                      <span className="text-xs font-medium text-[oklch(var(--accent-700))]">
                        {testimonial.name[0]}
                      </span>
                    </div>
                    <div>
                      <div className="text-sm font-medium text-foreground-950">{testimonial.name}</div>
                      <div className="text-xs text-foreground-500">{testimonial.role}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* FAQ */}
        <section className="px-4 md:px-6 py-10 md:py-14">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 text-center mb-2">
              常见问题
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-8">关于韩漫网的常见疑问解答</p>

            <div className="space-y-3">
              {[
                {
                  q: '韩漫网上的漫画真的免费吗？',
                  a: '是的，韩漫网上所有漫画资源均免费提供阅读。我们通过广告赞助和合作推广维持网站运营，不会向读者收取任何费用。',
                },
                {
                  q: '是否需要注册账号才能阅读？',
                  a: '不需要。韩漫网支持无需注册即可直接阅读所有漫画，打开网站就能立即开始。当然，注册账号可以享受阅读记录同步、收藏漫画等额外功能。',
                },
                {
                  q: '漫画更新频率是怎样的？',
                  a: '我们与多家韩国漫画平台保持合作，热门漫画通常在韩国发布后24小时内同步更新中文翻译版本。一般漫画的更新周期为1-7天不等。',
                },
                {
                  q: '支持哪些设备阅读？',
                  a: '韩漫网全面适配PC电脑、平板电脑和手机等各类设备。无论您使用什么设备，都能获得最佳的阅读体验。',
                },
                {
                  q: '如何找到我想看的漫画？',
                  a: '您可以通过首页的分类导航、搜索功能或热门推荐来找到感兴趣的漫画。我们的分类系统涵盖了所有主流漫画类型，方便您快速筛选。',
                },
              ].map((faq, index) => (
                <details key={index} className="bg-background-100 rounded-lg group">
                  <summary className="px-5 py-4 cursor-pointer flex items-center justify-between text-sm font-medium text-foreground-950 list-none">
                    {faq.q}
                    <i className="ri-arrow-down-s-line text-foreground-500 group-open:rotate-180 transition-transform" />
                  </summary>
                  <div className="px-5 pb-4 text-sm text-foreground-600 leading-relaxed">
                    {faq.a}
                  </div>
                </details>
              ))}
            </div>
          </div>
        </section>

        {/* Contact Information */}
        <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto">
            <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950 text-center mb-2">
              联系我们
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-8">
              如有任何问题或合作意向，欢迎通过以下方式联系我们
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-5">
              <div className="bg-background-50 rounded-lg p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-[oklch(var(--accent-100))]">
                  <i className="ri-mail-line text-xl text-[oklch(var(--accent-500))]" />
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">电子邮件</h3>
                <p className="text-xs text-foreground-600">contact@manhwa-read.com</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-[oklch(var(--accent-100))]">
                  <i className="ri-wechat-line text-xl text-[oklch(var(--accent-500))]" />
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">微信公众号</h3>
                <p className="text-xs text-foreground-600">韩漫网官方</p>
              </div>
              <div className="bg-background-50 rounded-lg p-5 text-center">
                <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-[oklch(var(--accent-100))]">
                  <i className="ri-qq-line text-xl text-[oklch(var(--accent-500))]" />
                </div>
                <h3 className="text-sm font-semibold text-foreground-950 mb-1">QQ群</h3>
                <p className="text-xs text-foreground-600">892415673</p>
              </div>
            </div>

            <div className="mt-10 bg-background-50 rounded-lg p-6">
              <h3 className="text-sm font-semibold text-foreground-950 mb-4 text-center">商务合作</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-sm text-foreground-600">
                <div className="flex items-start gap-3">
                  <i className="ri-briefcase-line text-lg text-[oklch(var(--accent-500))] mt-0.5" />
                  <div>
                    <div className="font-medium text-foreground-950 mb-1">广告合作</div>
                    <p className="text-xs">欢迎品牌方进行广告投放合作，精准触达漫画爱好者群体</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-translate-2 text-lg text-[oklch(var(--accent-500))] mt-0.5" />
                  <div>
                    <div className="font-medium text-foreground-950 mb-1">翻译合作</div>
                    <p className="text-xs">诚邀韩语翻译人才加入，共同为中文读者带来优质漫画翻译</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-link text-lg text-[oklch(var(--accent-500))] mt-0.5" />
                  <div>
                    <div className="font-medium text-foreground-950 mb-1">内容合作</div>
                    <p className="text-xs">欢迎韩国漫画平台与内容创作者洽谈授权合作</p>
                  </div>
                </div>
                <div className="flex items-start gap-3">
                  <i className="ri-user-star-line text-lg text-[oklch(var(--accent-500))] mt-0.5" />
                  <div>
                    <div className="font-medium text-foreground-950 mb-1">人才招聘</div>
                    <p className="text-xs">招募前端开发、编辑运营等各类人才加入我们的团队</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </main>

      <Footer />
      <ScrollToTopButton />
    </>
  );
}